import { Actor, type ActorSubclass, type HttpAgent } from '@dfinity/agent'
import { idlFactory as idlTopUpFactory } from '../idls/topUp/topUp'
import type { CanisterInfo, _SERVICE as TopUpFactory } from '../idls/topUp/topUp'
import { Principal } from '@dfinity/principal'

export const TOP_UP_CANISTER_ID = 'brqa2-2yaaa-aaaad-aal2a-cai'

export class TopUp {
  private agent: HttpAgent
  private actor: ActorSubclass<TopUpFactory>

  constructor(agent: HttpAgent) {
    this.agent = agent
    this.actor = Actor.createActor(idlTopUpFactory, {
      canisterId: TOP_UP_CANISTER_ID,
      agent: this.agent,
    }) as ActorSubclass<TopUpFactory>
  }

  getTopUpHistory(user: Principal) {
    return this.actor.get_top_up_history(user)
  }

  getProfile(user: Principal) {
    return this.actor.get_profile(user)
  }

  deleteCanister(canister: Principal) {
    return this.actor.delete_canister(canister)
  }

  registerManualTopup(canister: string, amount: bigint) {
    return this.actor.add_top_up_history({
      topup_type: [{ Manual: null }],
      canister: Principal.from(canister),
      timestamp: BigInt(Date.now() * 1_000_000),
      amount,
    })
  }

  async addCanister(canister: CanisterInfo) {
    const result = await this.actor.add_canister(canister)

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }

  async updateCanister(canister: CanisterInfo) {
    const { id, name, topup_amount, min_cycles, auto_topup, topup_type } = canister

    const result = await this.actor.update_canister_settings(
      id,
      [name],
      [topup_amount],
      [min_cycles],
      [auto_topup],
      [topup_type]
    )

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }
}
